/** Os campos enviados na tokenização do cartão. */
export interface DadosTokenizacao {
  documento: string
  nome_titular: string
  numero_cartao: string
  mes_ano_vencimento: string
  cvv: string
}

export interface CacheTokenCartao {
  /** Token já gerado para esta compra e estes dados de cartão, ou `null`. */
  buscar: (compra: string, dados: DadosTokenizacao) => string | null
  /** Guarda o token; substitui o que estiver guardado. */
  guardar: (compra: string, dados: DadosTokenizacao, token: string) => void
}

function chave(compra: string, { documento, nome_titular, numero_cartao, mes_ano_vencimento, cvv }: DadosTokenizacao) {
  return JSON.stringify([compra, documento, nome_titular, numero_cartao, mes_ano_vencimento, cvv])
}

/**
 * Cada tokenização cria um token novo no gateway e uma linha nova de cartão no
 * backend. As retentativas da mesma compra com o mesmo cartão reaproveitam o
 * token; mudar qualquer campo do cartão, ou a compra, gera outro. Só em
 * memória: nada vai para o storage.
 */
export default function criarCacheTokenCartao(): CacheTokenCartao {
  let guardado: { chave: string; token: string } | null = null

  function buscar(compra: string, dados: DadosTokenizacao) {
    return guardado !== null && guardado.chave === chave(compra, dados) ? guardado.token : null
  }

  function guardar(compra: string, dados: DadosTokenizacao, token: string) {
    guardado = { chave: chave(compra, dados), token }
  }

  return { buscar, guardar }
}
